import { GulfWar1990SummaryDescription } from '../../components/ToxicExposureSummary';
import {
  gulfWar1990SummaryPageTitle,
  titleWithSubtitle,
} from '../../content/toxicExposure';

export const uiSchema = {
  'ui:title': titleWithSubtitle(gulfWar1990SummaryPageTitle, 'Summary'),
  'ui:description': GulfWar1990SummaryDescription,
};

export const schema = {
  type: 'object',
  properties: {},
};
